export default function formatDateMonth(date) {
    const newDate = new Date(date);    
    const formatedDate = newDate?.toLocaleDateString('en-us', { month:"short", day:"numeric", year:"numeric"}) 
    
    return formatedDate
}